import axios from 'axios';
import get from 'lodash.get';

import { getPublisherScope } from 'core/utils/url-helper';

import queryString from 'core/libs/query-string';

/**
 * Документация по рекомендательной системе
 * https://rcm.rambler.ru/docs/api.html
 */
export function getRecommendations(options) {
  return new Promise((res, rej) => {
    window._top100q.push(function() {
      const {
        blockId,
        user,
        host,
        xuid,
        limit,
        ...params
      } = options;

      const {
        id: adtechUid,
        scope: adtechUidScope,
      } = window.top100Counter.getAdtechId();

      const query = queryString.stringify({
        ...params,
        user_id: get(user, 'userInfo.info.chain_id.default'),
        limit: limit || 10,
        xuid,
        adtech_uid: adtechUid,
        adtech_uid_scope: adtechUidScope,
        pub_id: xuid,
        pub_scope: getPublisherScope(host),
      });

      const url = `https://rcm.rambler.ru/api/v2/blocks/${blockId}/recommendations?${query}`;

      axios.get(url, {
        withCredentials: true,
        headers: {
          'Accept-Encoding': 'gzip',
          'Accept': 'application/json',
        },
      }).then(res).catch(rej);
    });
  });
}

export function isRamblerIdEnabled(context) {
  return Object.keys(context.ramblerId).length > 0;
}
